var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8333 7.5H7.49992C6.57944 7.5 5.83325 8.24619 5.83325 9.16667V14.1667C5.83325 15.0871 6.57944 15.8333 7.49992 15.8333H15.8333C16.7537 15.8333 17.4999 15.0871 17.4999 14.1667V9.16667C17.4999 8.24619 16.7537 7.5 15.8333 7.5Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6667 13.3333C12.5871 13.3333 13.3333 12.5871 13.3333 11.6667C13.3333 10.7462 12.5871 10 11.6667 10C10.7462 10 10 10.7462 10 11.6667C10 12.5871 10.7462 13.3333 11.6667 13.3333Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1667 7.50004V5.83338C14.1667 5.39135 13.9911 4.96743 13.6785 4.65487C13.366 4.3423 12.942 4.16671 12.5 4.16671H4.16667C3.72464 4.16671 3.30072 4.3423 2.98816 4.65487C2.67559 4.96743 2.5 5.39135 2.5 5.83338V10.8334C2.5 11.2754 2.67559 11.6993 2.98816 12.0119C3.30072 12.3244 3.72464 12.5 4.16667 12.5H5.83333",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgConsultationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationsIcon);
export default __webpack_public_path__ + "static/media/consultations-icon.057bba1448e578073b55683f338ddf5f.svg";
export { ForwardRef as ReactComponent };